module.exports = __webpack_public_path__ + "media/images/realizacje/real6-41c0aa32f21f4af716467b359bc6f968.png";